import { api } from '@/lib/api';

// --- DASHBOARD ---
export const getDashboard = (params?: any): Promise<any> => api.get(`/school/dashboard`, { params });
export const getDashboardFinance = (params?: any): Promise<any> => api.get(`/school/dashboard/finance`, { params });
export const getDashboardAcademics = (params?: any): Promise<any> => api.get(`/school/dashboard/academics`, { params });

// --- ADMISSIONS ---
export const getApplications = (params?: any): Promise<any> => api.get(`/school/applications`, { params });
export const postApplication = (body: any): Promise<any> => api.post(`/school/applications`, body);
export const decideApplication = (id: number, body: any): Promise<any> => api.post(`/school/applications/${id}/decide`, body);
export const enrolApplication = (id: number, body: any): Promise<any> => api.post(`/school/applications/${id}/enrol`, body);
export const scheduleExam = (id: number, body: any): Promise<any> => api.post(`/school/applications/${id}/schedule-exam`, body);
export const requestDocument = (id: number, body: any): Promise<any> => api.post(`/school/applications/${id}/request-document`, body);

// --- ADMISSION CYCLES & EXAMS ---
export const getAdmissionCycles = (params?: any): Promise<any> => api.get(`/school/admission-cycles`, { params });
export const postAdmissionCycle = (body: any): Promise<any> => api.post(`/school/admission-cycles`, body);
export const getEntranceExams = (params?: any): Promise<any> => api.get(`/school/entrance-exams`, { params });
export const postEntranceExam = (body: any): Promise<any> => api.post(`/school/entrance-exams`, body);

// --- STUDENTS ---
export const getStudents = (params?: any): Promise<any> => api.get(`/school/students`, { params });
export const postStudent = (body: any): Promise<any> => api.post(`/school/students`, body);

// --- FAMILIES (GUARDIANS) ---
export const getGuardians = (params?: any): Promise<any> => api.get(`/school/guardians`, { params });
export const postGuardian = (body: any): Promise<any> => api.post(`/school/guardians`, body);
export const getParentLinkRequests = (params?: any): Promise<any> => api.get(`/school/parent-link-requests`, { params });
export const approveParentLink = (id: number): Promise<any> => api.post(`/school/parent-link-requests/${id}/approve`);
export const rejectParentLink = (id: number): Promise<any> => api.post(`/school/parent-link-requests/${id}/reject`);

// --- ACADEMICS (CLASSES, LEVELS & SUBJECTS) ---
export const getClassLevels = (params?: any): Promise<any> => api.get(`/school/class-levels`, { params });
export const postClassLevel = (body: any): Promise<any> => api.post(`/school/class-levels`, body);
export const putClassLevel = (id: number, body: any): Promise<any> => api.put(`/school/class-levels/${id}`, body);

export const getClasses = (params?: any): Promise<any> => api.get(`/school/classes`, { params });
export const postClass = (body: any): Promise<any> => api.post(`/school/classes`, body);
export const putClass = (id: number, body: any): Promise<any> => api.put(`/school/classes/${id}`, body);
export const assignTeacherToClass = (classId: number, body: any): Promise<any> => api.post(`/school/classes/${classId}/assign-teacher`, body);

export const getSubjects = (params?: any): Promise<any> => api.get(`/school/subjects`, { params });
export const postSubject = (body: any): Promise<any> => api.post(`/school/subjects`, body);
export const putSubject = (id: number, body: any): Promise<any> => api.put(`/school/subjects/${id}`, body);

export const getAssessmentComponents = (params?: any): Promise<any> => api.get(`/school/assessment-components`, { params });
export const putAssessmentComponent = (id: number, body: any): Promise<any> => api.put(`/school/assessment-components/${id}`, body);

// --- ASSESSMENTS (CBT) ---
export const getSchoolCbtExams = (params?: any): Promise<any> => api.get(`/school/cbt-exams`, { params });
export const postSchoolCbtExam = (body: any): Promise<any> => api.post(`/teacher/cbt-exams`, body);

// --- WALLET & TRANSACTIONS ---
export const getOwnerWallet = (params?: any): Promise<any> => api.get(`/school/wallet`, { params });
export const getOwnerWalletBanks = (params?: any): Promise<any> => api.get(`/school/wallet/banks`, { params });
export const getOwnerWalletTransactions = (params?: any): Promise<any> => api.get(`/school/wallet/transactions`, { params });
export const getOwnerWalletTransaction = (id: string | number): Promise<any> => api.get(`/school/wallet/transactions/${id}`);
export const getOwnerWalletTransfers = (params?: any): Promise<any> => api.get(`/school/wallet/transfers`, { params });
export const postOwnerWalletCreate = (body: any): Promise<any> => api.post(`/school/wallet/create`, body);
export const postOwnerWalletLookupWallet = (body: any): Promise<any> => api.post(`/school/wallet/lookup-wallet`, body);
export const postOwnerWalletQuote = (body: any): Promise<any> => api.post(`/school/wallet/quote`, body);
export const postOwnerWalletResolveAccount = (body: any): Promise<any> => api.post(`/school/wallet/resolve-account`, body);
export const postOwnerWalletTransfer = (body: any, pin?: string, key?: string): Promise<any> => api.post(`/school/wallet/transfer`, body, { headers: {'x-pin': pin, 'Idempotency-Key': key} });
export const postOwnerWalletTransferWallet = (body: any, pin?: string, key?: string): Promise<any> => api.post(`/school/wallet/transfer-wallet`, body, { headers: {'x-pin': pin, 'Idempotency-Key': key} });

// --- WITHDRAWALS & BANK ACCOUNTS ---
export const getSchoolWithdrawals = (params?: any): Promise<any> => api.get(`/school/withdrawals`, { params });
export const postSchoolWithdrawal = (body: any, pin?: string, key?: string): Promise<any> => api.post(`/school/withdrawals`, body, { headers: { 'x-pin': pin, 'x-idempotency-key': key } });
export const approveOwnerWithdrawal = (id: string | number, pin?: string, key?: string): Promise<any> => api.post(`/school/withdrawals/${id}/approve`, {}, { headers: { 'x-pin': pin, 'x-idempotency-key': key } });
export const rejectOwnerWithdrawal = (id: string | number, reason: string, key?: string): Promise<any> => api.post(`/school/withdrawals/${id}/reject`, { reason }, { headers: { 'x-idempotency-key': key } });
export const getSchoolBankAccounts = (params?: any): Promise<any> => api.get(`/school/bank-accounts`, { params });
export const postSchoolBankAccount = (body: any): Promise<any> => api.post(`/school/bank-accounts`, body);
export const postSchoolBankAccountVerify = (body: any): Promise<any> => api.post(`/school/bank-accounts/verify`, body);
export const approveSchoolBankAccount = (id: string | number): Promise<any> => api.post(`/school/bank-accounts/${id}/approve`);
export const deleteSchoolBankAccount = (id: string | number): Promise<any> => api.delete(`/school/bank-accounts/${id}`);

// --- FINANCE & STAFF ---
export const getFeeStructures = (params?: any): Promise<any> => api.get(`/school/fee-structures`, { params });
export const getInvoices = (params?: any): Promise<any> => api.get(`/school/invoices`, { params });
export const getPayments = (params?: any): Promise<any> => api.get(`/school/payments`, { params });
export const getExpenses = (params?: any): Promise<any> => api.get(`/school/expenses`, { params });
export const getPayrollRuns = (params?: any): Promise<any> => api.get(`/school/payroll/runs`, { params });
export const getStaff = (params?: any): Promise<any> => api.get(`/school/staff`, { params });

// --- TYPES ---
export interface OwnerWalletInfo { exists: boolean; balance: number; account_number?: string; bank_name?: string; account_name?: string; status?: string; next_step?: string; can_create?: boolean; funding_account?: any; }
export interface OwnerWalletQuote { amount: number; charge: number; total: number; }
export interface OwnerWalletTransaction { id: number; type: 'credit' | 'debit'; amount: number; balance_after: number; status: string; created_at: string; narration?: string; category?: string; counterparty?: { account_name: string }; }
export interface OwnerWalletCreateBody { bvn: string; nin: string; first_name: string; last_name: string; date_of_birth: string; phone_number: string; email: string; address: string; business_name?: string; }
export interface OwnerWithdrawal { id: number; amount: number; status: string; created_at: string; requested_by?: string; fee?: number; failure_reason?: string; can_approve?: boolean; bank_account?: { bank_name: string; account_number: string; account_name: string }; }
export interface SchoolBankAccount { id: number; bank_name: string; account_number: string; account_name: string; verified: boolean; is_default: boolean; purpose?: string; }

// --- DELETE CLASS LEVEL ---
export const deleteClassLevel = (id: number): Promise<any> => api.delete(`/school/class-levels/${id}`);
export const deleteClass = (id: number): Promise<any> => api.delete(`/school/classes/${id}`);

// --- SUBJECTS & TEACHER ASSIGNMENTS ---
export const deleteSubject = (id: number): Promise<any> => api.delete(`/school/subjects/${id}`);
export const getTeacherAssignments = (params?: any): Promise<any> => api.get(`/school/teacher-assignments`, { params });
export const postTeacherAssignment = (body: any): Promise<any> => api.post(`/school/teacher-assignments`, body);
export const deleteTeacherAssignment = (id: number): Promise<any> => api.delete(`/school/teacher-assignments/${id}`);

// --- STUDENT ACTIONS ---
export const getStudentById = (id: number): Promise<any> => api.get(`/school/students/${id}`);
export const putStudent = (id: number, body: any): Promise<any> => api.put(`/school/students/${id}`, body);
export const withdrawStudent = (id: number, body: any): Promise<any> => api.post(`/school/students/${id}/withdraw`, body);
export const reinstateStudent = (id: number, body?: { school_class_id: number; password?: string }): Promise<any> => api.post(`/school/students/${id}/reinstate`, body);
export const transferStudentClass = (id: number, body: any): Promise<any> => api.post(`/school/students/${id}/transfer-class`, body);

/** Per-student attendance — NO dedicated endpoint exists.
 *  We try /school/attendance with student_id filter.
 *  If the backend doesn't support the filter, this returns all school attendance. */
export const getStudentAttendance = (id: number, params?: any): Promise<any> =>
  api.get(`/school/attendance/report`, { params: { student_id: id, ...params } });

/** Per-student subjects — NO dedicated endpoint exists.
 *  We try /school/subject-registrations with student_id filter. */
export const getStudentSubjects = (id: number, params?: any): Promise<any> =>
  api.get(`/school/subject-registrations`, { params: { student_id: id, ...params } });

/** Class-level results — the endpoint is /school/results/class. */
export const getClassResults = (classId: number, params?: any): Promise<any> =>
  api.get(`/school/results/class`, { params: { class_id: classId, ...params } });

/** Alias — StudentProfilePage imports `linkGuardianToStudent`, your owner.ts has `linkGuardianStudent`. */
export const linkGuardianToStudent = (guardianId: number, body: any): Promise<any> =>
  api.post(`/school/guardians/${guardianId}/link-student`, body);


// ────────────────────────────────────────────────────────
// RECOVERY — re-added after overly-aggressive Python delete
// ────────────────────────────────────────────────────────

export const getTerms = (params?: any): Promise<any> =>
  api.get(`/school/terms`, { params });

export const getStudentDocuments = (id: number): Promise<any> =>
  api.get(`/school/students/${id}/documents`);

export const uploadStudentDocument = (id: number, formData: FormData): Promise<any> =>
  api.post(`/school/students/${id}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// ═══════════════════════════════════════════════════════════
// FEES & INVOICES — matches Bursar\FeeController + Bursar\InvoiceController
// ═══════════════════════════════════════════════════════════

// ── Fee heads (line items: Tuition, PTA levy, Books…) ──
export const getFeeHeads = (params?: any): Promise<any> => api.get('/school/fee-heads', { params });
export const postFeeHead = (body: any): Promise<any> => api.post('/school/fee-heads', body);
export const putFeeHead = (id: number, body: any): Promise<any> => api.put(`/school/fee-heads/${id}`, body);

// ── Fee structures (templates) ──
// NOTE: `getFeeStructures` is already declared in the FINANCE block above — do not redeclare
export const getFeeStructureById = (id: number): Promise<any> => api.get(`/school/fee-structures/${id}`);
export const postFeeStructure = (body: any): Promise<any> => api.post('/school/fee-structures', body);
export const putFeeStructure = (id: number, body: any): Promise<any> => api.put(`/school/fee-structures/${id}`, body);
export const postFeeStructureItem = (id: number, body: any): Promise<any> => api.post(`/school/fee-structures/${id}/items`, body);
export const postFeeStructureTargets = (id: number, body: any): Promise<any> => api.post(`/school/fee-structures/${id}/targets`, body);
export const activateFeeStructure = (id: number): Promise<any> => api.post(`/school/fee-structures/${id}/activate`);
export const generateInvoicesFromStructure = (id: number): Promise<any> => api.post(`/school/fee-structures/${id}/generate-invoices`);

// ── Invoices ──
// NOTE: `getInvoices` is already declared in the FINANCE block above
export const getInvoiceById = (id: number): Promise<any> => api.get(`/school/invoices/${id}`);
export const postInvoice = (body: any): Promise<any> => api.post('/school/invoices', body);
export const cancelInvoice = (id: number, body: { reason: string }): Promise<any> => api.post(`/school/invoices/${id}/cancel`, body);
export const writeOffInvoice = (id: number, body: { reason: string }): Promise<any> => api.post(`/school/invoices/${id}/write-off`, body);
export const remindInvoice = (id: number, body?: { channels?: string[] }): Promise<any> =>
  api.post(`/school/invoices/${id}/remind`, body);
export const setInvoiceInstallments = (id: number, body: { parts: { due_date: string; amount: number }[] }): Promise<any> =>
  api.post(`/school/invoices/${id}/installments`, body);

// ── Debtors (aggregate across invoices) ──
export const getDebtors = (params?: any): Promise<any> => api.get('/school/debtors', { params });
export const remindAllDebtors = (body?: any): Promise<any> => api.post('/school/debtors/remind-all', body);

// ── Discounts (sibling rule, scholarships) ──
export const getDiscounts = (params?: any): Promise<any> => api.get('/school/discounts', { params });
export const postDiscount = (body: any): Promise<any> => api.post('/school/discounts', body);
export const approveDiscount = (id: number): Promise<any> => api.post(`/school/discounts/${id}/approve`);
export const putSiblingRule = (body: { discount_id: number | null }): Promise<any> =>
  api.put('/school/discounts/sibling-rule', body);
export const applyDiscount = (body: { discount_id: number; student_ids: number[]; term_id?: number }): Promise<any> =>
  api.post('/school/discounts/apply', body);

// ── Payments (offline recording — exact shape pending PaymentController review) ──
export const postPaymentRecord = (body: any): Promise<any> => api.post('/school/payments/record', body);

// ═══════════════════════════════════════════════════════════
// RESULTS MODULE — Sessions, Terms, Results workflow, Grading
// ═══════════════════════════════════════════════════════════

// ── SESSIONS ──
export const getSessions = (params?: any): Promise<any> => api.get('/school/sessions', { params });
export const postSession = (body: any): Promise<any> => api.post('/school/sessions', body);
export const putSession = (id: number, body: any): Promise<any> => api.put(`/school/sessions/${id}`, body);
export const activateSession = (id: number): Promise<any> => api.post(`/school/sessions/${id}/activate`);
export const closeSession = (id: number): Promise<any> => api.post(`/school/sessions/${id}/close`);

// ── TERMS (getTerms already exists in recovery block — not redeclared) ──
export const postTerm = (body: any): Promise<any> => api.post('/school/terms', body);
export const putTerm = (id: number, body: any): Promise<any> => api.put(`/school/terms/${id}`, body);
export const activateTerm = (id: number): Promise<any> => api.post(`/school/terms/${id}/activate`);

// ── RESULTS WORKFLOW (getClassResults already exists — not redeclared) ──
export const computeResults = (body: { class_id: number; term_id: number }): Promise<any> =>
  api.post('/school/results/compute', body);
export const approveResults = (body: { class_id: number; term_id: number }): Promise<any> =>
  api.post('/school/results/approve', body);
export const publishResults = (body: { class_id: number; term_id: number }): Promise<any> =>
  api.post('/school/results/publish', body);
export const putResultHoldNote = (resultId: number, body: { note: string }): Promise<any> => api.put(`/school/results/${resultId}/hold-note`, body);
export const holdResult = (resultId: number, body: { reason: 'unpaid_fees' | 'disciplinary' | 'manual'; note: string }): Promise<any> =>
  api.post(`/school/results/${resultId}/hold`, body);
export const releaseResult = (resultId: number, body: { note: string }): Promise<any> =>
  api.post(`/school/results/${resultId}/release`, body);
export const getResultSheet = (resultId: number): Promise<any> =>
  api.get(`/school/results/${resultId}/sheet`);
export const getBroadsheet = (params: { class_id: number; term_id: number }): Promise<any> =>
  api.get('/school/results/broadsheet', { params });
export const refreshBroadsheetPositions = (body: { class_id: number; term_id: number }): Promise<any> =>
  api.post('/school/results/broadsheet/positions', body);
export const getAnnualResults = (params: { class_id: number; session_id: number }): Promise<any> =>
  api.get('/school/results/annual', { params });
export const computeAnnualResults = (body: { class_id: number; session_id: number; publish?: boolean }): Promise<any> =>
  api.post('/school/results/annual/compute', body);
export const exportResults = (body: any): Promise<any> =>
  api.post('/school/results/export', body);

// ── SUBJECT REGISTRATIONS ──
export const getSubjectRegistrations = (params: any): Promise<any> =>
  api.get('/school/subject-registrations', { params });
export const saveSubjectRegistrations = (body: any): Promise<any> =>
  api.post('/school/subject-registrations', body);

// ── GRADING SCALES ──
export const getGradingScales = (params?: any): Promise<any> => api.get('/school/grading-scales', { params });
export const postGradingScale = (body: any): Promise<any> => api.post('/school/grading-scales', body);
export const putGradingScale = (id: number, body: any): Promise<any> => api.put(`/school/grading-scales/${id}`, body);

// ── ASSESSMENT COMPONENTS — create (get/put already exist above) ──
export const postAssessmentComponent = (body: any): Promise<any> =>
  api.post('/school/assessment-components', body);

// ── RESULT TEMPLATES ──
export const getResultTemplates = (params?: any): Promise<any> => api.get('/school/result-templates', { params });
export const postResultTemplate = (body: any): Promise<any> => api.post('/school/result-templates', body);
export const putResultTemplate = (id: number, body: any): Promise<any> => api.put(`/school/result-templates/${id}`, body);
export const deleteResultTemplate = (id: number): Promise<any> => api.delete(`/school/result-templates/${id}`);

// ── RESULT SIGNATORIES ──
export const getResultSignatories = (params?: any): Promise<any> => api.get('/school/result-signatories', { params });
export const postResultSignatory = (body: any): Promise<any> => api.post('/school/result-signatories', body);
export const putResultSignatory = (id: number, body: any): Promise<any> => api.put(`/school/result-signatories/${id}`, body);
export const deleteResultSignatory = (id: number): Promise<any> => api.delete(`/school/result-signatories/${id}`);

// ── COMPOSITE SUBJECTS ──
export const getCompositeSubjects = (params?: any): Promise<any> => api.get('/school/composite-subjects', { params });
export const postCompositeSubject = (body: any): Promise<any> => api.post('/school/composite-subjects', body);
export const putCompositeSubject = (id: number, body: any): Promise<any> => api.put(`/school/composite-subjects/${id}`, body);
export const deleteCompositeSubject = (id: number): Promise<any> => api.delete(`/school/composite-subjects/${id}`);

// ── TRANSCRIPTS ──
export const postTranscript = (body: { student_id: number }): Promise<any> =>
  api.post('/school/transcripts', body);
export const getTranscript = (id: number): Promise<any> =>
  api.get(`/school/transcripts/${id}`);

// ═══════════════════════════════════════════════════════════
// STAFF, ROLES, CLOCK-IN, WITHDRAWALS
// ═══════════════════════════════════════════════════════════

// ── STAFF ──
export const getStaffById = (id: number): Promise<any> => api.get(`/school/staff/${id}`);
export const putStaff = (id: number, body: any): Promise<any> => api.put(`/school/staff/${id}`, body);
export const deactivateStaff = (id: number): Promise<any> => api.post(`/school/staff/${id}/deactivate`);
export const resetStaffPassword = (id: number): Promise<any> => api.post(`/school/staff/${id}/reset-password`);

// ── ROLES & PERMISSIONS ──
export const getRoles = (params?: any): Promise<any> => api.get('/school/roles', { params });
export const postRole = (body: any): Promise<any> => api.post('/school/roles', body);
export const putRole = (id: number, body: any): Promise<any> => api.put(`/school/roles/${id}`, body);
export const deleteRole = (id: number): Promise<any> => api.delete(`/school/roles/${id}`);
export const getPermissions = (params?: any): Promise<any> => api.get('/school/permissions', { params });

// ── STAFF CLOCK-IN ──
export const getStaffAttendance = (params?: any): Promise<any> => api.get('/school/staff-attendance', { params });
export const postStaffAttendanceManual = (body: any): Promise<any> => api.post('/school/staff-attendance/manual', body);

// ── STAFF create (invite) ──
export const postStaff = (body: any): Promise<any> => api.post('/school/staff', body);

// ═══════════════════════════════════════════════════════════
// TIMETABLE — full CRUD
// ═══════════════════════════════════════════════════════════
export const getTimetable = (params?: any): Promise<any> => api.get('/school/timetable', { params });
export const postTimetableEntry = (body: any): Promise<any> => api.post('/school/timetable', body);
export const putTimetableEntry = (id: number, body: any): Promise<any> => api.put(`/school/timetable/${id}`, body);
export const deleteTimetableEntry = (id: number): Promise<any> => api.delete(`/school/timetable/${id}`);

// ═══════════════════════════════════════════════════════════
// PAYROLL — salary setup, allowances, deductions, runs, history
// ═══════════════════════════════════════════════════════════
export const getSalaryGrades = (params?: any): Promise<any> => api.get('/school/salary-grades', { params });
export const postSalaryGrade = (body: any): Promise<any> => api.post('/school/salary-grades', body);
export const getPayrollSalaries = (params?: any): Promise<any> => api.get('/school/payroll/salaries', { params });
export const putPayrollSalary = (userId: number, body: any): Promise<any> => api.put(`/school/payroll/salaries/${userId}`, body);
export const deletePayrollSalary = (userId: number): Promise<any> => api.delete(`/school/payroll/salaries/${userId}`);
export const postPayrollIncrement = (body: any): Promise<any> => api.post('/school/payroll/increments', body);
export const getPayrollAllowances = (params?: any): Promise<any> => api.get('/school/payroll/allowances', { params });
export const postPayrollAllowance = (body: any): Promise<any> => api.post('/school/payroll/allowances', body);
export const getPayrollDeductions = (params?: any): Promise<any> => api.get('/school/payroll/deductions', { params });
export const postPayrollDeduction = (body: any): Promise<any> => api.post('/school/payroll/deductions', body);
export const postPayrollRun = (body: any): Promise<any> => api.post('/school/payroll/runs', body);
export const getPayrollRunById = (id: number): Promise<any> => api.get(`/school/payroll/runs/${id}`);
export const computePayrollRun = (id: number): Promise<any> => api.post(`/school/payroll/runs/${id}/compute`);
export const submitPayrollRun = (id: number): Promise<any> => api.post(`/school/payroll/runs/${id}/submit`);
export const approvePayrollRun = (id: number, pin?: string): Promise<any> =>
  api.post(`/school/payroll/runs/${id}/approve`, {}, { headers: pin ? { 'X-Pin': pin } : {} });
export const payPayrollRun = (id: number, pin?: string): Promise<any> =>
  api.post(`/school/payroll/runs/${id}/pay`, {}, { headers: pin ? { 'X-Pin': pin } : {} });
export const getPayrollHistory = (params?: any): Promise<any> => api.get('/school/payroll/history', { params });
export const getPayrollReports = (params?: any): Promise<any> => api.get('/school/payroll/reports', { params });
export const getPayrollPayslip = (id: number): Promise<any> => api.get(`/school/payroll/payslips/${id}`);

// ═══════════════════════════════════════════════════════════
// EXPENSES + BOOKS
// ═══════════════════════════════════════════════════════════
export const getExpenseCategories = (params?: any): Promise<any> => api.get('/school/expense-categories', { params });
export const postExpenseCategory = (body: any): Promise<any> => api.post('/school/expense-categories', body);
export const postExpense = (body: any): Promise<any> => api.post('/school/expenses', body);
export const putExpense = (id: number, body: any): Promise<any> => api.put(`/school/expenses/${id}`, body);
export const approveExpense = (id: number, pin?: string, bankData?: any): Promise<any> => api.post(`/school/expenses/${id}/approve`, bankData || {}, { headers: pin ? { 'x-pin': pin } : {} });
export const rejectExpense = (id: number, body: { reason: string }): Promise<any> => api.post(`/school/expenses/${id}/reject`, body);
export const getBooksProfitLoss = (params?: any): Promise<any> => api.get('/school/books/profit-loss', { params });
export const getBooksLedger = (params?: any): Promise<any> => api.get('/school/books/ledger', { params });
export const getBooksBudgets = (params?: any): Promise<any> => api.get('/school/books/budgets', { params });
export const postBooksBudget = (body: any): Promise<any> => api.post('/school/books/budgets', body);

// ═══════════════════════════════════════════════════════════
// PHASE 1 ADDITIONS — composite subjects, subject registration,
// attendance (functions already declared elsewhere are skipped)
// ═══════════════════════════════════════════════════════════

// Subject registration — save function already exists; expose the list helper alias
export const getSubjectRegistrationsByClass = (classId: number, termId: number): Promise<any> =>
  api.get('/school/subject-registrations', { params: { class_id: classId, term_id: termId } });

// Attendance — mark and report helpers
export const getAttendance = (params: { class_id?: number; student_id?: number; date?: string; term_id?: number }): Promise<any> =>
  api.get('/school/attendance', { params });

export const getAttendanceReport = (params: { class_id: number; from?: string; to?: string }): Promise<any> =>
  api.get('/school/attendance/report', { params });

export const markAttendance = (body: { class_id: number; date: string; entries: { student_id: number; status: string; note?: string }[] }): Promise<any> =>
  api.post('/school/attendance/mark', body);

// ═══════════════════════════════════════════════════════════
// BATCH 2 — COMMS, SETTINGS, ALUMNI
// ═══════════════════════════════════════════════════════════

// ── NOTICES (read via common, manage via school) ──
export const getNoticesList = (params?: any): Promise<any> => api.get('/notices', { params });
export const postNotice = (body: any): Promise<any> => api.post('/school/notices', body);
export const putNotice = (id: number, body: any): Promise<any> => api.put(`/school/notices/${id}`, body);
export const deleteNotice = (id: number): Promise<any> => api.delete(`/school/notices/${id}`);

// ── CALENDAR (read via common, manage via school) ──
export const getCalendarEvents = (params?: any): Promise<any> => api.get('/calendar', { params });
export const postCalendarEvent = (body: any): Promise<any> => api.post('/school/calendar', body);
export const putCalendarEvent = (id: number, body: any): Promise<any> => api.put(`/school/calendar/${id}`, body);
export const deleteCalendarEvent = (id: number): Promise<any> => api.delete(`/school/calendar/${id}`);

// ── BIRTHDAYS ──
export const getBirthdays = (params?: any): Promise<any> => api.get('/school/birthdays', { params });
export const celebrateBirthday = (body: any): Promise<any> => api.post('/school/birthdays/celebrate', body);

// ── AUDIT LOG ──
export const getAuditLogs = (params?: any): Promise<any> => api.get('/school/audit-logs', { params });

// ── BRANDING / PROFILE ──
export const getSchoolProfile = (params?: any): Promise<any> => api.get('/school/profile', { params });
export const putSchoolProfile = (body: any): Promise<any> => api.put('/school/profile', body);
export const putSchoolBranding = (body: any): Promise<any> => api.put('/school/branding', body);
export const putResultTheme = (body: any): Promise<any> => api.put('/school/result-theme', body);

// ── ALUMNI ──
export const getAlumni = (params?: any): Promise<any> => api.get('/school/alumni', { params });
export const getAlumniById = (id: number): Promise<any> => api.get(`/school/alumni/${id}`);
export const getAlumniRequests = (params?: any): Promise<any> => api.get('/school/alumni-requests', { params });
export const processAlumniRequest = (id: number, body?: any): Promise<any> => api.post(`/school/alumni-requests/${id}/process`, body);
export const deliverAlumniRequest = (id: number, body?: any): Promise<any> => api.post(`/school/alumni-requests/${id}/deliver`, body);

// ═══════════════════════════════════════════════════════════
// AUDIT FIX — missing functions
// ═══════════════════════════════════════════════════════════
export const putGuardian = (id: number, body: any): Promise<any> =>
  api.put(`/school/guardians/${id}`, body);

export const deleteGuardianStudent = (guardianId: number, studentId: number): Promise<any> =>
  api.delete(`/school/guardians/${guardianId}/students/${studentId}`);

export const importStudents = (formData: FormData): Promise<any> =>
  api.post('/school/students/import', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

/** Replace the subjects a class offers. Backend shape: { subjects: [{ subject_id, is_compulsory, pass_mark }] } */
export interface ClassSubjectInput { subject_id: number; is_compulsory: boolean; pass_mark: number }
export const setClassSubjects = (classId: number, subjects: ClassSubjectInput[]): Promise<any> =>
  api.post(`/school/classes/${classId}/subjects`, { subjects });
/** @deprecated kept for old callers; maps subject_ids to the backend's { subjects: [...] } shape. */
export const assignSubjectToClass = (classId: number, body: { subject_ids: number[] }): Promise<any> =>
  setClassSubjects(classId, body.subject_ids.map((id) => ({ subject_id: id, is_compulsory: true, pass_mark: 40 })));

// ═══════════════════════════════════════════════════════════
// PROFILE + FEES + LINK FIXES
// ═══════════════════════════════════════════════════════════
export const getStudentPaymentReference = (id: number): Promise<any> =>
  api.get(`/school/students/${id}/payment-reference`);

export const getFeeClearance = (params: { student_id?: number; class_id?: number; term_id?: number }): Promise<any> =>
  api.get('/school/fee-clearance', { params });

export const postFeeClearance = (studentId: number, body: any): Promise<any> =>
  api.post(`/school/fee-clearance/${studentId}`, body);

// ═══════════════════════════════════════════════════════════
// STUDENT DOCUMENTS — delete + request
// ═══════════════════════════════════════════════════════════
export const deleteStudentDocument = (studentId: number, documentId: number): Promise<any> =>
  api.delete(`/school/students/${studentId}/documents/${documentId}`);

export const requestStudentDocument = (studentId: number, body: { type: string; note?: string }): Promise<any> =>
  api.post(`/school/students/${studentId}/request-document`, body);


// ═══════════════════════════════════════════════════════════
// DOCUMENT REQUESTS — tracking + accept/decline
// ═══════════════════════════════════════════════════════════
export const getStudentDocumentRequests = (studentId: number, params?: any): Promise<any> =>
  api.get(`/school/students/${studentId}/document-requests`, { params });

export const acceptStudentDocumentRequest = (studentId: number, requestId: number): Promise<any> =>
  api.post(`/school/students/${studentId}/document-requests/${requestId}/accept`);

export const declineStudentDocumentRequest = (studentId: number, requestId: number, reason: string): Promise<any> =>
  api.post(`/school/students/${studentId}/document-requests/${requestId}/decline`, { reason });

// ═══════════════════════════════════════════════════════════
// PHASE 2 — Promotions, Reports, Support, Calendar admin
// ═══════════════════════════════════════════════════════════

// ─── Promotions & Graduation ───
export const getPromotions = (params?: { class_id?: number; session_id?: number; term_id?: number }): Promise<any> =>
  api.get('/school/promotions', { params });
export const postPromotionsPreview = (body: any): Promise<any> =>
  api.post('/school/promotions/preview', body);

export const postPromotionsManual = (body: {
  from_class_id: number;
  to_class_id?: number;
  student_ids?: number[];
  decision: 'promote' | 'repeat' | 'graduate';
  reason?: string;
}): Promise<any> =>
  api.post('/school/promotions/manual', body);
export const postPromotionsApply = (body: any): Promise<any> =>
  api.post('/school/promotions/apply', body);
export const postPromotionsRevert = (id: number, body: any): Promise<any> =>
  api.post(`/school/promotions/${id}/revert`, body);
export const postGraduationRun = (body: any): Promise<any> =>
  api.post('/school/graduation/run', body);

// ─── Reports & Exports ───
export const getReportsAttendance = (params?: any): Promise<any> =>
  api.get('/school/reports/attendance', { params });
export const getReportsEnrolment = (params?: any): Promise<any> =>
  api.get('/school/reports/enrolment', { params });
export const getReportsFinance = (params?: any): Promise<any> =>
  api.get('/school/reports/finance', { params });
export const getReportsResults = (params?: any): Promise<any> =>
  api.get('/school/reports/results', { params });
export const postReportsExport = (body: { type: 'attendance' | 'enrolment' | 'finance' | 'results'; params?: any }): Promise<any> =>
  api.post('/school/reports/export', body);
export const getExportsById = (id: number): Promise<any> =>
  api.get(`/school/exports/${id}`);
export const getExportsDownload = (id: number): Promise<any> =>
  api.get(`/school/exports/${id}/download`, { responseType: 'blob' });

// ─── Alumni requests ───
export const postAlumniRequestsDeliver = (id: number, body?: any): Promise<any> =>
  api.post(`/school/alumni-requests/${id}/deliver`, body);
export const postAlumniRequestsProcess = (id: number, body?: any): Promise<any> =>
  api.post(`/school/alumni-requests/${id}/process`, body);

// ─── Calendar admin ───
export const getSchoolCalendar = (params?: any): Promise<any> =>
  api.get('/school/calendar', { params });
export const postSchoolCalendar = (body: any): Promise<any> =>
  api.post('/school/calendar', body);
export const putSchoolCalendar = (id: number, body: any): Promise<any> =>
  api.put(`/school/calendar/${id}`, body);
export const deleteSchoolCalendar = (id: number): Promise<any> =>
  api.delete(`/school/calendar/${id}`);

// ─── Notices admin ───
export const getSchoolNotices = (params?: any): Promise<any> =>
  api.get('/school/notices', { params });
export const postSchoolNotice = (body: any): Promise<any> =>
  api.post('/school/notices', body);
export const putSchoolNotice = (id: number, body: any): Promise<any> =>
  api.put(`/school/notices/${id}`, body);
export const deleteSchoolNotice = (id: number): Promise<any> =>
  api.delete(`/school/notices/${id}`);

// ─── Uniforms ───
export const getSchoolUniforms = (params?: any): Promise<any> =>
  api.get('/school/uniforms', { params });
export const putSchoolUniforms = (body: any): Promise<any> =>
  api.put('/school/uniforms', body);

// ─── Birthdays ───
export const getSchoolBirthdays = (params?: any): Promise<any> =>
  api.get('/school/birthdays', { params });
export const postSchoolBirthdayCelebrate = (body: any): Promise<any> =>
  api.post('/school/birthdays/celebrate', body);

// ─── School settings + permissions + audit ───
export const getSchoolSettings = (): Promise<any> =>
  api.get('/school/settings');
export const putSchoolSettings = (body: any): Promise<any> =>
  api.put('/school/settings', body);
export const getSchoolPermissions = (): Promise<any> =>
  api.get('/school/permissions');
export const getSchoolAuditLogs = (params?: any): Promise<any> =>
  api.get('/school/audit-logs', { params });

// ─── Support tickets + sessions (school-side) ───
export const getSupportTickets = (params?: any): Promise<any> =>
  api.get('/school/support/tickets', { params });
export const postSupportTicket = (body: any): Promise<any> =>
  api.post('/school/support/tickets', body);
export const getSupportTicketById = (id: number): Promise<any> =>
  api.get(`/school/support/tickets/${id}`);
export const postSupportTicketReply = (id: number, body: any): Promise<any> =>
  api.post(`/school/support/tickets/${id}/reply`, body);
export const getSupportSessions = (params?: any): Promise<any> =>
  api.get('/school/support/sessions', { params });
export const postSupportSession = (body: any): Promise<any> =>
  api.post('/school/support/sessions', body);
export const postSupportSessionsAccept = (id: number): Promise<any> =>
  api.post(`/ojp/support-sessions/${id}/accept`);
export const postSupportSessionsEnd = (id: number): Promise<any> =>
  api.post(`/ojp/support-sessions/${id}/end`);


export const getClassById = (id: number): Promise<any> =>
  api.get(`/school/classes/${id}`);


export const deleteGradingScale = (id: number): Promise<any> =>
  api.delete(`/school/grading-scales/${id}`);

export const deleteAssessmentComponent = (id: number): Promise<any> =>
  api.delete(`/school/assessment-components/${id}`);


export const getProfile = (): Promise<any> => api.get('/school/profile');

export const putProfile = (body: { name?: string; motto?: string | null; logo_path?: string | null; email?: string; phone?: string; address?: string; city?: string; state?: string; school_type?: string }): Promise<any> =>
  api.put('/school/profile', body);


export const getResultsPreviewSample = (params?: { class_id?: number; term_id?: number }): Promise<any> =>
  api.get('/school/results/preview-sample', { params });


// ═══════════════════════════════════════════════════════════
// WALLET — supplementary exports
// ═══════════════════════════════════════════════════════════
export const postPaymentAccountsProvision = (): Promise<any> =>
  api.post('/school/payment-accounts/provision');

export const postWalletKyc = (body: any): Promise<any> =>
  api.post('/school/wallet/kyc', body);

export const postAuthPinSet = (body: {
  pin: string;
  pin_confirmation?: string;
  current_password?: string;
}): Promise<any> => api.post('/auth/pin/set', body);

export const postAuthPinChange = (body: { current_pin: string; new_pin: string; new_pin_confirmation: string }): Promise<any> =>
  api.post('/auth/pin/change', body);


// Expense submission with optional receipt file (multipart)
export const postExpenseMultipart = (formData: FormData): Promise<any> =>
  api.post('/school/expenses', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

// Expense submit as plain JSON (no receipt)
export const postExpenseJson = (body: any, pin?: string): Promise<any> =>
  api.post('/school/expenses', body, { headers: pin ? { 'x-pin': pin } : {} });


export const getWalletExistingCustomers = (): Promise<any> =>
  api.get('/school/wallet/existing');

export const postWalletLink = (accountNumber: string): Promise<any> =>
  api.post('/school/wallet/link', { account_number: accountNumber });


export const getAuthMe = (): Promise<any> => api.get('/auth/me');


export const getWalletFindAccount = (accountNumber: string): Promise<any> =>
  api.post('/school/wallet/find-account', { account_number: accountNumber });


export const postOwnerWalletUnlink = (): Promise<any> =>
  api.post('/school/wallet/unlink');

export const deleteFeeStructure = (id: number): Promise<any> =>
  api.delete(`/school/fee-structures/${id}`);

export const deactivateFeeStructure = (id: number): Promise<any> =>
  api.post(`/school/fee-structures/${id}/deactivate`);

export const deleteFeeHead = (id: number): Promise<any> =>
  api.delete(`/school/fee-heads/${id}`);


// ── Platform invoices (OJP charges: renewals, SMS, fees) ──
export const getPlatformInvoices = (params?: any): Promise<any> =>
  api.get('/school/platform-invoices', { params });

export const getPlatformInvoiceById = (id: number): Promise<any> =>
  api.get(`/school/platform-invoices/${id}`);


export const deleteInvoice = (id: number): Promise<any> =>
  api.delete(`/school/invoices/${id}`);

export const bulkDeleteInvoices = (body: { class_id?: number; term_id?: number; session_id?: number; status?: string; confirm: 'DELETE' }): Promise<any> =>
  api.post('/school/invoices/bulk-delete', body);

export const purgeInvoices = (body: { confirm: 'DELETE ALL INVOICES' }): Promise<any> =>
  api.post('/school/invoices/purge', body);

export const putInvoice = (id: number, body: { notes?: string; due_date?: string }): Promise<any> =>
  api.put(`/school/invoices/${id}`, body);

export const getApplicationsById = (id: number): Promise<any> =>
  api.get(`/school/applications/${id}`);

export const postApplicationsVerifyDocuments = (id: number, body: any): Promise<any> =>
  api.post(`/school/applications/${id}/verify-documents`, body);

export const postApplicationsConfirmPayment = (id: number, body: { method: string; note?: string }): Promise<any> =>
  api.post(`/school/applications/${id}/confirm-payment`, body);

export const postApplicationsScheduleExam = (id: number, body: any): Promise<any> =>
  api.post(`/school/applications/${id}/schedule-exam`, body);

export const postApplicationsExamScore = (id: number, body: any): Promise<any> =>
  api.post(`/school/applications/${id}/exam-score`, body);

export const postApplicationsRequestDocument = (id: number, body: any): Promise<any> =>
  api.post(`/school/applications/${id}/request-document`, body);

export const postApplicationsRemind = (id: number, body?: any): Promise<any> =>
  api.post(`/school/applications/${id}/remind`, body);

export const putAdmissionCycle = (id: number, body: any): Promise<any> =>
  api.put(`/school/admission-cycles/${id}`, body);

export const getClockinQrActive = (): Promise<any> => api.get('/school/clockin/qr/active');

export const postClockinQr = (): Promise<any> => api.post('/school/clockin/qr');

export const postClockinQrRevoke = (): Promise<any> => api.post('/school/clockin/qr/revoke');

export const getClockinRules = (): Promise<any> => api.get('/school/clockin/rules');

export const putClockinRules = (body: any): Promise<any> => api.put('/school/clockin/rules', body);

export const getClockinReport = (params?: any): Promise<any> => api.get('/school/clockin/report', { params });

export const postClockinManual = (body: any): Promise<any> => api.post('/school/clockin/manual', body);

export const deletePayrollDeduction = (id: number): Promise<any> => api.delete(`/school/payroll/deductions/${id}`);

export const getClockinEvents = (): Promise<any> => api.get('/school/clockin/events');
export const postClockinEvent = (body: any): Promise<any> => api.post('/school/clockin/events', body);
export const deleteClockinEvent = (id: number): Promise<any> => api.delete(`/school/clockin/events/${id}`);
export const generateEventQr = (id: number): Promise<any> => api.post(`/school/clockin/events/${id}/generate-qr`);

export const getSchoolSubscription = (): Promise<any> => api.get('/school/subscription');


export const getSubscription = (): Promise<any> => api.get('/school/subscription');

// ── Auto-renewal + platform invoice payment ──
export const postSubscriptionAutoRenew = (body: any, pin?: string): Promise<any> =>
  api.post('/school/subscription/auto-renew', body, { headers: { 'x-pin': pin } });
export const postPlatformInvoicePay = (id: number, pin?: string): Promise<any> =>
  api.post(`/school/platform-invoices/${id}/pay`, {}, { headers: { 'x-pin': pin } });